import { render, staticRenderFns } from "./CloseVisit.vue?vue&type=template&id=0ef8cf72&scoped=true&"
import script from "./CloseVisit.vue?vue&type=script&lang=js&"
export * from "./CloseVisit.vue?vue&type=script&lang=js&"
import style0 from "./CloseVisit.vue?vue&type=style&index=0&id=0ef8cf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8cf72",
  null
  
)

export default component.exports